module.exports = require('./lib').default;
module.exports.default = module.exports;
module.exports.NextButton = require('./lib').NextButton;
module.exports.PreviousButton = require('./lib').PreviousButton;
module.exports.PagingDots = require('./lib').PagingDots;



//////////////////
// WEBPACK FOOTER
// ./~/nuka-carousel/index.js
// module id = 1022
// module chunks = 19843951674672